import * as React from "react";
import { AutoCompleteInput, Checkbox, ColorPicker, Input } from "uxp/components";
import { findAvailableFields, IPropertyEditorProps, IUIPropertyDefinition } from "../../../common/common";
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from "../../../common/ui-props/common";
import jp from 'jsonpath'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ActionEditorLink, { IAction } from "../../../common/action-editor/ActionEditor";
import { bindContainerId } from "../../../../util";
import { Conditional } from "../../../common/ConditionalComponent";
import { NumberInput } from "../GridLayout/GridLayoutWidgetProperty";

export interface IEventListProps {
    dateField: string,
    titleField: string,
    subTitleField: string,
    showTime?: boolean
    onClickRow?: IAction,
    thumbnailBG?: string,
    thumbnailText?: string,
    titleColor?: string,
    subTitleColor?: string,
    seperatorColor?: string,
    titleFontSize?: string,
    subTitleFontSize?: string
}

export function EventListProperty(title: string, props: IEventListProps): IUIPropertyDefinition<IEventListProps> {
    return {
        defaults: props,
        render: (props, uxpContext, contextData, containerId) => {

            let _props = props.uiProps

            let possibleValues = {};
            findAvailableFields(props.parentUIProps.source, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();


            return <PropertyContainer>
                <PropertyContainerTitle>{title}</PropertyContainerTitle>
                <PropertyGroup>
                    <PropertyGroupTitle>Date field</PropertyGroupTitle>
                    <Property>
                        <PropertyTitle>Field</PropertyTitle>
                        <AutoCompleteInput
                            value={_props.dateField}
                            onChange={s => {
                                jp.apply(_props, '$.dateField', () => (s))
                                props.onChange(_props)
                            }}
                            options={pv}
                            className="widget-designer-input"
                        />
                    </Property>

                    <Property>
                        <PropertyTitle> Background color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props.thumbnailBG}
                            onChange={s => {
                                jp.apply(_props, '$.thumbnailBG', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Text color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props.thumbnailText}
                            onChange={s => {
                                jp.apply(_props, '$.thumbnailText', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Property>

                        <Checkbox
                            checked={_props.showTime}
                            onChange={s => {
                                jp.apply(_props, '$.showTime', () => (s))
                                props.onChange(_props)
                            }}
                            label="Show Time"
                        />
                    </Property>
                </PropertyGroup>

                <PropertyGroup>
                    <PropertyGroupTitle>Title Field</PropertyGroupTitle>
                    <Property>
                        <PropertyTitle>Field</PropertyTitle>
                        <AutoCompleteInput
                            value={_props.titleField}
                            onChange={s => {
                                jp.apply(_props, '$.titleField', () => (s))
                                props.onChange(_props)
                            }}
                            options={pv}
                            className="widget-designer-input"
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props.titleColor}
                            onChange={s => {
                                jp.apply(_props, '$.titleColor', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Size(px)</PropertyTitle>
                        <Input
                            type='number'
                            value={escapeUnit(_props.titleFontSize || '', 'px')}
                            onChange={s => {
                                jp.apply(_props, '$.titleFontSize', () => (s))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                            inputAttr={{
                                max: '200',
                                min: '8'
                            }}
                        />
                    </Property>
                </PropertyGroup>

                <PropertyGroup>
                    <PropertyGroupTitle>Sub title field</PropertyGroupTitle>
                    <Property>
                        <PropertyTitle>Field</PropertyTitle>
                        <AutoCompleteInput
                            value={_props.subTitleField}
                            onChange={s => {
                                jp.apply(_props, '$.subTitleField', () => (s))
                                props.onChange(_props)
                            }}
                            options={pv}
                            className="widget-designer-input"
                        />
                    </Property>

                    <Property>
                        <PropertyTitle> Color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props.subTitleColor}
                            onChange={s => {
                                jp.apply(_props, '$.subTitleColor', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>Size(px)</PropertyTitle>
                        <Input
                            type='number'
                            value={escapeUnit(_props.subTitleFontSize || '', 'px')}
                            onChange={s => {
                                jp.apply(_props, '$.subTitleFontSize', () => (s))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                            inputAttr={{
                                max: '200',
                                min: '8'
                            }}
                        />
                    </Property>

                </PropertyGroup>
                <PropertyGroup>
                    <PropertyGroupTitle>Other</PropertyGroupTitle>



                    <Property>
                        <PropertyTitle>On click an item </PropertyTitle>
                        <ActionEditorLink
                            uiProps={props.parentUIProps}
                            uxpContext={uxpContext}
                            action={_props.onClickRow}
                            onChange={s => {
                                jp.apply(_props, '$.onClickRow', () => (s))
                                props.onChange(_props)
                            }}
                            contextData={contextData}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle> Seperator color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props.seperatorColor}
                            onChange={s => {
                                jp.apply(_props, '$.seperatorColor', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>


                </PropertyGroup>
            </PropertyContainer>
        }
    };
}